import React from "react";
import ScoreHorizontal, { ScorePeriodBox, ScorePeriodBoxFight } from 'components/common/ScoreHorizontal'
import { findArray } from 'helpers/utils'

import Label from "components/general/Label";
import SportCode from "components/common/SportCode";

const KteScore = ({ data, category, state, handleClick }) => {

  let score;
  if (data?.results) {
    let duration = findArray(data?.results?.extendedInfos, { ei_code: ['DURATION'] })?.ei_value;
    let overtime = findArray(data?.results?.extendedInfos, { ei_code: ['GOLD_SCORE'] });
    let matchDuration;
    let matchOvertime = overtime?.extensions?.find(filter => (filter.eie_code === 'DURATION' && filter.eie_pos === '2'))?.eie_value;;
    if (duration) {
      matchDuration = <><Label data='HeaderContestTime' />: {duration}</>
    }
    if (matchOvertime) {
      matchOvertime = <><Label data='HeaderOvertime' />: {matchOvertime}</>
    }
    let unit = data?.results?.eventUnit?.description;
    let numberGame = findArray(data?.results?.extendedInfos, { ei_code: ['UNIT_NUMBER'] }).ei_value;
    let presentationGame = unit;
    let noExpandible = true;
    if (numberGame) {
      presentationGame = <>{presentationGame}, <Label data='HeaderContest' /> {numberGame} </>;
    }

    score = <ScoreHorizontal
      data={data}

      noExpandible={noExpandible}
      state={state}

      scoreHeader={{
        left: presentationGame,
      }}
      scoreFooter={
        {
          top: <Periods data={data} />,
          bottom: <>{matchDuration} {matchOvertime}</>,
        }
      }
    />

  }
  return (
    <>
      {score}
    </>
  )
}

function Periods({ data }) {
  let home = findArray(data?.results?.items, { startSortOrder: [1] });
  console.log(home)
  let homeIPP = home?.extendedResults?.find(filter => (filter.er_code === 'IPP'))?.er_value;
  let homeWAZ = home?.extendedResults?.find(filter => (filter.er_code === 'WAZ'))?.er_value;
  let homeYUK = home?.extendedResults?.find(filter => (filter.er_code === 'YUK'))?.er_value;

  let away = findArray(data?.results?.items, { startSortOrder: [2] });
  let awayIPP = away?.extendedResults?.find(filter => (filter.er_code === 'IPP'))?.er_value;
  let awayWAZ = away?.extendedResults?.find(filter => (filter.er_code === 'WAZ'))?.er_value;
  let awayYUK = away?.extendedResults?.find(filter => (filter.er_code === 'YUK'))?.er_value;

  let resultCode = findArray(data?.results?.extendedInfos, { ei_code: ['RES_CODE'] }).ei_value;
  console.log(home)
  return (
    <>
      <div className="w-100 d-none d-md-flex justify-content-center">
        <ScorePeriodBoxFight
          key={'scorePeriodBlockenaltiesHome'}
          periodTop={<Label data='HeaderYuko' />}
          periodBottom={homeYUK} />

        <ScorePeriodBoxFight
          key={'scorePeriodBlockWazaariHome'}
          periodTop={<Label data='HeaderWazaari' />}
          periodBottom={homeWAZ} />

        <ScorePeriodBoxFight
          key={'scorePeriodBlockIppoHome'}
          periodTop={<Label data='HeaderIppon' />}
          periodBottom={homeIPP} />

        <div className='score-horizontal-period-name m-1'>
          {resultCode ? <><Label data={home?.resultWLT.includes('T') ? 'HeaderDrawnBy' : 'HeaderWonBy'} /> <SportCode discipline='KTE' entity='@ResultCode' code={resultCode} /></> : ''}
        </div>

        <ScorePeriodBoxFight
          key={'scorePeriodBlockPenaltiesAway'}
          periodTop={<Label data='HeaderYuko' />}
          periodBottom={awayYUK} />

        <ScorePeriodBoxFight
          key={'scorePeriodBlockWazaariAway'}
          periodTop={<Label data='HeaderWazaari' />}
          periodBottom={awayWAZ} />

        <ScorePeriodBoxFight
          key={'scorePeriodBlockIpponAway'}
          periodTop={<Label data='HeaderIppon' />}
          periodBottom={awayIPP} />
      </div>

      <div className="w-100 d-flex d-md-none justify-content-center">
        <div className="d-flex-block col-4">
          <div className="row w-100 m-0">
            <div className="col-8 text-end score-horizontal-text08 p-0"><Label data='HeaderYuko' /></div>
            <div className="col-4 score-horizontal-text08 text-center p-0">{homeYUK}</div>
          </div>
          <div className="row w-100 m-0">
            <div className="col-8 text-end score-horizontal-text08 p-0"><Label data='HeaderWazaari' /></div>
            <div className="col-4 score-horizontal-text08 text-center p-0">{homeWAZ}</div>
          </div>
          <div className="row w-100 m-0">
            <div className="col-8 text-end score-horizontal-text08 p-0"><Label data='HeaderIppon' /></div>
            <div className="col-4 score-horizontal-text08 text-center p-0">{homeIPP}</div>
          </div>
        </div>

        <div className="text-center col-4"><strong>{resultCode ? <SportCode discipline='KTE' entity='@ResultCode' code={resultCode} /> : ''}</strong></div>

        <div className="d-flex-block col-4">
          <div className="row w-100 m-0">
            <div className="col-4 text-end score-horizontal-text08 text-center p-0">{awayYUK}</div>
            <div className="col-8 text-start score-horizontal-text08 p-0"><Label data='HeaderYuko' /></div>
          </div>
          <div className="row w-100 m-0">
            <div className="col-4 text-end score-horizontal-text08 text-center p-0">{awayWAZ}</div>
            <div className="col-8 text-start score-horizontal-text08 p-0"><Label data='HeaderWazaari' /></div>
          </div>
          <div className="row w-100 m-0">
            <div className="col-4 text-end score-horizontal-text08 text-center p-0">{awayIPP}</div>
            <div className="col-8 text-start score-horizontal-text08 p-0"><Label data='HeaderIppon' /></div>
          </div>
        </div>
      </div>
    </>
  )
}

export default KteScore;